export { TutorStudentProfilePage, type TutorStudentProfilePageProps } from "./TutorStudentProfilePage"
